import React, { isValidElement } from 'react'
import { Grid, Stack, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import { isUndefined } from 'lodash'
import Action from 'components/action/Action'

const SummaryIndicator = ({ title, subTitle, content, secondaryContent, onClick, bgColor = 'primary.veryLight', outlined, borderColor = 'black', size = 'auto', actions = [] }) => {
    const filteredActions = actions.filter(a => a.displayed || isUndefined(a.displayed))
    const outlinedStyle = outlined ? {
        border: '1px solid',
        borderColor,
    } : {}
    const clickableStyle = onClick ? { cursor: 'pointer' } : {}

    return (
        <Grid
            container
            size={size}
            justifyContent={'space-between'}
            direction={'column'}
            bgcolor={bgColor}
            spacing={1}
            sx={{ padding: 1.5, borderRadius: 2, ...outlinedStyle, ...clickableStyle }}
            onClick={onClick || (() => {})}
        >
            <Stack>
                <Grid container alignItems={'center'} justifyContent={'space-between'}>
                    {isValidElement(title) ?
                        title
                        :
                        <Typography color={'third'} sx={{ fontSize: '14px', fontWeight: 'bold' }}>{title}</Typography>
                    }
                    {filteredActions.length > 0 && (
                        <Grid container size='auto' spacing={0.5} alignItems={'center'}>
                            {filteredActions.map(action => (
                                <Grid key={actions.indexOf(action)} size='auto'>
                                    {isValidElement(action) ? action : (<Action {...action} />)}
                                </Grid>
                            ))}
                        </Grid>
                    )}
                </Grid>
                <Typography color={'third'} sx={{ fontSize: '11px' }}>{subTitle}</Typography>
            </Stack>
            <Grid container size={12} spacing={1} alignItems={'center'}>
                {isValidElement(content) ?
                    content
                    :
                    <Typography color={'third'} sx={{ fontSize: 25, fontWeight: 'bold' }}>{content}</Typography>
                }
                {secondaryContent}
            </Grid>
        </Grid>
    )
}

SummaryIndicator.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    subTitle: PropTypes.string,
    content: PropTypes.element,
    secondaryContent: PropTypes.element,
    onClick: PropTypes.func,
    bgColor: PropTypes.string,
    outlined: PropTypes.bool,
    borderColor: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    actions: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.shape({
            icon: PropTypes.string,
            tooltip: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.element,
            ]),
            onClick: PropTypes.func,
            color: PropTypes.string,
            displayed: PropTypes.bool,
            size: PropTypes.string,
            'data-cy': PropTypes.string,
        }),
    ])),
}

export default SummaryIndicator